import { Navigate } from "react-router-dom"
import { isAuthenticated, isTokenExpired } from "../services/Auth"

function AuthRoute({ children, redirectTo }){
    const Autenticado = (isAuthenticated() && !isTokenExpired())
    return Autenticado ? children : <Navigate to={redirectTo} />
}

export default AuthRoute